import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, NewsCategorySummaryDisplayItem, NewsDateSummaryDisplayItem, NewsDisplayItem, NewsInputItem, NewsSearchOptions, NewsUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace NewsRoutes {
    export const GetAll = ApiRoute.Define({
        URL: `news`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<NewsDisplayItem>
    });

    export const GetCategories = ApiRoute.Define({
        URL: `summary/news/categories`,
        Kind: RequestKind.Post,
        ResultType: DisplayItemCollection<NewsCategorySummaryDisplayItem>
    });

    export const GetMonths = ApiRoute.Define({
        URL: `summary/news/months`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<NewsDateSummaryDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: (schoolID: string) => schoolID ? `search/schools/${schoolID}/news` : `search/news`,
        Kind: RequestKind.Post,
        BodyType: NewsSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<NewsDisplayItem>
    });

    export const ResetUnseenCount = ApiRoute.Define({
        URL: `news/unseen`,
        Kind: RequestKind.Put,
        ResultType: boolean
    });

    export namespace Posts {
        export const Get = ApiRoute.Define({
            URL: (postID: string) => `news/${postID}`,
            Kind: RequestKind.Get,
            ResultType: NewsDisplayItem
        });

        export const Add = ApiRoute.Define({
            URL: `news`,
            Kind: RequestKind.Post,
            BodyType: NewsInputItem,
            ResultType: string
        });

        export const Update = ApiRoute.Define({
            URL: (postID: string) => `news/${postID}`,
            Kind: RequestKind.Put,
            BodyType: NewsUpdateItem,
            ResultType: boolean
        });

        export const Delete = ApiRoute.Define({
            URL: (postID: string) => `news/${postID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }
}
